import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import _ from "lodash";
import {messageActions, responseOptionActions, tagActions} from "_actions";
import {getPlatform, PLATFORM} from "../MessageDetailsUtils";
import useViewMessageDetails from "./useViewMessageDetails";

export default function () {
    const dispatch = useDispatch();
    const effectRan = useRef(false);
    const params = useParams();
    const messageId = _.get(params, 'id');
    const platform = getPlatform(messageId);

    useEffect(() => {
        if(effectRan.current === false) {
            getConversation();
            return () => effectRan.current = true;
        }
    }, []);

    const getConversation = () => {
        dispatch(messageActions.clearUpdatedPracticePriority());
        dispatch(responseOptionActions.clearAddedResponseOption());
        dispatch(tagActions.resetTagsList());
        dispatch(responseOptionActions.getAll({message: messageId}));

        if (platform === PLATFORM.TEAMS) {
            dispatch(messageActions.getTeamsMessage(messageId));
        } else if (platform === PLATFORM.TRENDS) {
            dispatch(messageActions.getTrendsMessage(messageId));
        }
    }

    const { message, loadingMessage } = useViewMessageDetails();
    return { message, loadingMessage };
}